module.exports = __webpack_public_path__ + "static/media/coneflowed-trio.1722829f.jpg";